const { h, render, Component } = require('preact');

class Checkbox extends Component {
  constructor(props) {
    super(props);
    this.changeCheckBoxState = this.changeCheckBoxState.bind(this)
    this.isInputValid = this.isInputValid.bind(this)
    this.isInputGiven = this.isInputGiven.bind(this)
    this.validateInput = this.validateInput.bind(this)
    this.getCheckBoxElement = this.getCheckBoxElement.bind(this)
    this.populateInput = this.populateInput.bind(this)
  }

  changeCheckBoxState() {
    this.props.updateState(this.props.attrs.type, this.props.attrs.counter, this.populateInput(), this.isInputValid())
  }

  isInputGiven() {
    return this.isInputValid()
  }

  readInput() {
    return this.getCheckBoxElement().checked
  }

  isInputValid() {
    if (this.props.attrs.required  == "true") {
      return this.readInput()
    }
    return true
  }

  validateInput() {
    var showinvalidInputMsg = this.props.attrs.required && !this.readInput()
    if (showinvalidInputMsg)
      this.getInputInvalidHtmlElement().style.display = 'block'
    else
      this.getInputInvalidHtmlElement().style.display = 'none'
  }


  getCheckBoxElement() {
    var elementId = "checkbox_input" + this.props.attrs.counter
    return document.getElementById(elementId)
  }

  getInputInvalidHtmlElement() {
    return document.getElementsByClassName('.inputInvalidMsgID')[0]
  }

  populateInput() {
    var data = {}
    var inputData = this.readInput()
    data.description = `\n\n ${this.props.attrs.label} : ${inputData}`
    return data
  }

  componentDidMount() {
    var checkBox = this.getCheckBoxElement();
    checkBox.addEventListener("change", this.changeCheckBoxState)
  }

  render() {
    let attrs = this.props.attrs
    return (
        <div>
          <input type="checkbox" class="checkbox_input" data-bhw={"checkbox_input"+ attrs.counter} id={"checkbox_input" + attrs.counter} name="checkbox"/>
          <label for={"checkbox_input"+ attrs.counter}>
            {attrs.required == "true" ? (<span class="mandatory-field"> * </span>) : null}
          <span><strong>{attrs.label}</strong></span>
          </label>
          <span class="inputInvalidMsgID invalid-input initially-hidden error" >
          {I18n.translate('js.modules.support.checkbox_invalid_input_msg')}
          </span>
        </div>
    )
  }
}

module.exports = Checkbox
